<template>
  <v-app id="sendlink" style="height: 50%">
    <v-card :loading="loading" class="mx-auto my-12">
      <v-card-title>Send an E-Mail link to your colleagues</v-card-title>
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-card-text>
          <v-row align="center" class="mx-0">
            <v-combobox
              v-model="email"
              :items="userdata"
              item-text="user_email"
              item-value="user_email"
              multiple
              dense
              chips
              small-chips
              label="To"
            ></v-combobox>
          </v-row>

          <v-row align="center" class="mx-0">
            <v-text-field
              v-model="subject"
              label="Subject"
            ></v-text-field>
          </v-row>

          <v-row align="center">
            <v-textarea
              :counter="500"
              v-model="message"
              outlined
              label="Message"
              value=""
            ></v-textarea>
          </v-row>
        </v-card-text>

        <v-card-actions>
          <v-btn color="deep-purple lighten-2" text @click="validate">
            Send
          </v-btn>
          <v-btn color="deep-purple lighten-2" text @click="Cancel">
            Cancel
          </v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-app>
</template>

<script>
import axios from "axios";
export default {
  name: "SendLink",
  components: {},
  data: () => ({
    entry_id: "",
    isLoading: false,
    loading: false,
    valid: true,
    email: "",
    mail_send: false,
    userdata: [],
    product_id: "",
    username: "",
  }),
  props: ["subject","message"],
  mounted() {
    this.getUser();
  },
  methods: {
    Cancel() {
      var view = this;
      view.message = "";
      this.email = "";
      view.$emit("cancelEmail", 1);
    },
    validate() {
      var view = this;
      var endPoint = "";
      view.mail_send = true;

      if (this.$refs.form.validate()) {
        endPoint = view.$url("SEND_EMAIL_URL");
        let send_email_url_ep = this.$url("SEND_EMAIL_URL");
        console.log(send_email_url_ep);
        let token = view.$utils.getAccessToken();
        let formData = {
          subject: view.subject,
          message: view.message,
          user_email: view.email,
          product_id: view.$store.getters["ProductData/getProductId"],
          entry_id: view.$store.getters["ProductData/getEntryId"],
          username: view.$utils.getCookies("username").replace(/['"]+/g, ""),
          from_email: view.$utils.getCookies("email").replace(/['"]+/g, ""),
          product_link: window.location.href,
        };
        axios
          .post(endPoint, formData, {
            headers: {
              Authorization: token,
              contentType: "application/json",
              userid: view.$utils.getCookies("user_id"),
            },
          })
          .then(function () {
            view.subject = "Link to a product of your interest";
            view.message = "";
            view.email = "";
            view.$swal.fire({
              position: "bottom-end",
              icon: "success",
              title: "Email Send Successfully",
            });
          })
          .catch(function (response) {
            console.log(response);
            view.$swal.fire({
              position: "bottom-end",
              icon: "error",
              title: "Error:Something wrong",
            });
          });
        this.$emit("sendEmail", true);
      }
    },

    getUser() {
      var view = this;
      var endPoint = view.$url("GET_USERS");
      view
        .$fetch(
          {
            url: endPoint,
            type: "GET",
            contentType: "application/json",
          },
          {
            operation: "view",
            vueScope: view,
          }
        )
        .then((response) => {
          view.userdata = response.data.userdata;
        });
    },
  },
};
</script>

<style lang='sass' scoped>
@import './../assets/sass/company'
</style>